/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { useEffect } from 'react';
import { CandidateWithAge } from '~/definitions/candidate';
import { getStore } from '~/mobx/AppStore';

type Props = {
    candidates?: CandidateWithAge[];
};

const Client = (props: Readonly<Props>) => {
    const { candidateStore } = getStore();
    const { candidates = [] } = props;

    useEffect(() => {
        candidateStore.setCandidates(candidates);
    }, [candidates]);

    return null;
};

export default Client;
